<template>
  <v-container style="height: 400px">
    <v-row class="fill-height" align-content="center" justify="center">
      <v-col class="subtitle-1 text-center" cols="12">
        {{ title }}
      </v-col>
      <v-col cols="4">
        <v-progress-linear
          color="primary"
          indeterminate
          rounded
          height="6"
        ></v-progress-linear>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  props: {
    title: String
  }
}
</script>
